import React from 'react'
import PackageComponent from '../../Package'
import { Category_Today } from '../../../utils/formatType'

export default function TodayCategory() {
  return (
    <div>
            <PackageComponent title="Đề xuất hôm nay" packageId={Category_Today} />

    </div>
  )
}
